<div class="flex--column flex--nowrap orders flex__child--auto overflow-auto">
  <div class="wrapper--spacing-horizontal">
    <div class="orders__location-summary" *ngIf="(location$ | async) && (customer$ | async)">
      <agr-location-summary
        [location]="location$ | async"
        [customer]="customer$ | async"
        [title]="'app.orders.title' | translate"
        [subtitle]="'app.orders.description-all-orders' | translate"
      ></agr-location-summary>
    </div>

    <div class="orders--filter spacing--margin-vertical">
      <agr-filter *ngIf="filterConfig" [config]="filterConfig" [formControl]="filterControl"></agr-filter>
    </div>

    <div>
      <app-orders-table [data$]="filteredOrders$" [showAllOrders]="true"></app-orders-table>
    </div>
  </div>
</div>
